const URL = process.env.NEXT_PUBLIC_API_BASE_PATH;

const buildEndpoint = (subApi: string) => {
  if (process.env.NEXT_PUBLIC_NODE_ENV === 'local') return URL;
  return `${URL}/${subApi}`;
};

export enum ApiNames {
  Lists = 'CastingListsApi',
  Galleries = 'CastingGalleriesApi',
  CastCompanies = 'CastingCompaniesApi',
  Bookings = 'CastingBookingsApi',
  CastingProjects = 'CastingProjectsApi',
  ProjectLocations = 'ProjectLocationsApi',
  Locations = 'LocationsApi',
  Permissions = 'PermissionsApi',
  Photos = 'PhotosApi',
  CastingSearch = 'CastingSearchApi',
  CastingApplications = 'CastingApplicationsApi',
  UserPhotos = 'UserPhotosApi',
  Integrations = 'IntegrationsApi',
  Vehicles = 'Vehicles',
  Jobs = 'CastingJobsApi',
  Reports = 'ReportsApi',
  PayRates = 'PayRatesApi',
  CastingUsers = 'CastingUsersApi',
  PayrollToCasting = 'PayrollToCastingApi',
  CastingPayrollI9 = 'CastingPayrollI9Api',
}

export const awsApiConfig: AwsApiConfig = {
  endpoints: [
    {
      name: ApiNames.Lists,
      endpoint: buildEndpoint('cast_list'),
    },
    {
      name: ApiNames.CastingSearch,
      endpoint: buildEndpoint('cast_search'),
    },
    {
      name: ApiNames.Galleries,
      endpoint: buildEndpoint('cast_galleries'),
    },
    {
      name: ApiNames.CastCompanies,
      endpoint: buildEndpoint('cast_com'),
    },
    {
      name: ApiNames.Bookings,
      endpoint: buildEndpoint('cast_bookings'),
    },
    {
      name: ApiNames.CastingProjects,
      endpoint: buildEndpoint('cast_proj'),
    },
    {
      name: ApiNames.ProjectLocations,
      endpoint: buildEndpoint('castingprol'),
    },
    {
      name: ApiNames.Locations,
      endpoint: buildEndpoint('castingloc'),
    },
    {
      name: ApiNames.Permissions,
      endpoint: buildEndpoint('cast_emp'),
    },
    {
      name: ApiNames.Photos,
      endpoint: buildEndpoint('cast_phot/photos'),
    },
    {
      name: ApiNames.CastingUsers,
      endpoint: buildEndpoint('castingusrs/users'),
    },
    {
      name: ApiNames.CastingApplications,
      endpoint: buildEndpoint('cast_applications'),
    },
    {
      name: ApiNames.UserPhotos,
      endpoint: buildEndpoint('cast_uphot/casting/userPhotos'),
    },
    {
      name: ApiNames.Integrations,
      endpoint: buildEndpoint('integrations'),
    },
    {
      name: ApiNames.Vehicles,
      endpoint: buildEndpoint('castingusrs'),
    },
    {
      name: ApiNames.Jobs,
      endpoint: buildEndpoint('cast_jobs'),
    },
    {
      name: ApiNames.Reports,
      endpoint: buildEndpoint('cast_reports'),
    },
    {
      name: ApiNames.PayRates,
      endpoint: buildEndpoint('cast_pay_r'),
    },
    {
      name: ApiNames.PayrollToCasting,
      endpoint: buildEndpoint('payroll_to_casting'),
    },
    {
      name: ApiNames.CastingPayrollI9,
      endpoint: buildEndpoint('casting_payroll_i9'),
    },
  ],
};
